import { RadioButton } from './radio-button';

export class RadioButtonGroupConfig {
  private _name: string;
  private _value: string;
  private _defaultValue: string;
  private _readonly: boolean;
  private _required: boolean;
  private _controlName: string;
  private _radioButtonOptions: RadioButton[];

  constructor(
    radioButtonOptions: RadioButton[],
    controlName: string = '',
    name: string = '',
    value: string = '',
    defaultValue: string = '',
    readonly: boolean = false,
    required: boolean = false
  ) {
    this._name = name ? name : '';
    this._value = value ? value : '';
    this._defaultValue = defaultValue ? defaultValue : '';
    this._readonly = readonly ? readonly : false;
    this._required = required ? required : false;
    this._controlName = controlName ? controlName : '';
    this._radioButtonOptions = radioButtonOptions ? radioButtonOptions : [];
  }


  /**
   * Getter name
   */
  public get name(): string {
    return this._name;
  }

  public setValue(val: string) {
    this._value = val;
  }
  /**
   * Getter value
   */
  public get value(): string {
    return this._value;
  }

  /**
   * Getter defaultValue
   */
  public get defaultValue(): string {
    return this._defaultValue;
  }

  /**
   * Getter readonly
   */
  public get readonly(): boolean {
    return this._readonly;
  }

  /**
   * Getter required
   */
  public get required(): boolean {
    return this._required;
  }

  /**
   * Getter controlName
   */
  public get controlName(): string {
    return this._controlName;
  }

  /**
   * Getter radioButtonOptions
   */
  public get radioButtonOptions(): RadioButton[] {
    return this._radioButtonOptions;
  }



}
